if (!customElements.get('quick-add-modal')) {
  class QuickAddModal extends HTMLElement {
    constructor() {
      super();
      this.modalContent = this.querySelector('.quick-add-modal__content-info');
    }

    connectedCallback() {
      const toggleElement = this.querySelector('.quick-add-modal__toggle');

      toggleElement.addEventListener('click', function () {
        this.hide();
        this.style = null;
      }.bind(this));

      this.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() === 'ESCAPE') this.hide();
      });
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });

      this.moveModalOnScreenSizeChange();

      const mediaQueryList = window.matchMedia('(min-width: 768px)');
      mediaQueryList.addEventListener('change', this.moveModalOnScreenSizeChange.bind(this));
    }

    moveModalOnScreenSizeChange() {
      const isDesktop = window.matchMedia('(min-width: 768px)').matches;
      const modalElements = document.querySelectorAll('quick-add-modal');

      modalElements.forEach(modal => {
        if (!isDesktop) {
          if (modal.parentNode !== document.body) {
            modal.originalParent = modal.parentNode;
            document.body.appendChild(modal);
          }
        } else {
          if (modal.originalParent && modal.parentNode !== modal.originalParent) {
            modal.originalParent.appendChild(modal);
            delete modal.originalParent;
          }
        }
      });
    }

    show(opener) {
      this.openedBy = opener;
      this.style.opacity = '0';
      this.style.visibility = 'hidden';
      this.setAttribute('open', '');

      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');
      opener.querySelector('.loading__spinner').classList.remove('hidden');

      fetch(opener.getAttribute('data-product-url'))
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');

          this.productElement.classList.forEach((classApplied) => {
            if (classApplied.startsWith('color-') || classApplied === 'gradient')
              this.modalContent.classList.add(classApplied);
          });

          this.preventDuplicatedIDs();
          this.removeDOMElements();
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

          if (window.ProductModel) window.ProductModel.loadShopifyXR();

          this.preventVariantURLSwitching();
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          opener.querySelector('.loading__spinner').classList.add('hidden');
          this.style.opacity = '1';
          this.style.visibility = 'visible';
        });


      if (window.matchMedia('(max-width: 767px)').matches) {
        document.body.classList.add('overflow-hidden');
      }

      trapFocus(this, this.querySelector('[role="dialog"]'));
      window.pauseAllMedia();
    }

    hide() {

      if (window.matchMedia('(max-width: 767px)').matches) {
        this.querySelector('.quick-add-modal__content').style.transform = 'translateX(-50%) translateY(100%)';
      }

      setTimeout(() => {
        this.removeAttribute('open');
        this.querySelector('.quick-add-modal__content').style.transform = '';
        this.modalContent.innerHTML = '';
        if (this.openedBy) {
          this.openedBy = null;
        }
        // Unlock the body only if the screen size is mobile
        if (window.matchMedia('(max-width: 767px)').matches) {
          document.body.classList.remove('overflow-hidden');
        }
        document.body.dispatchEvent(new CustomEvent('modalClosed'));
        removeTrapFocus(this.openedBy);
        window.pauseAllMedia();
        this.style.visibility = '';
        this.style.opacity = '';
      }, 1000);
    }
    setInnerHTML(element, html) {
      element.innerHTML = html;

      element.querySelectorAll('script').forEach((oldScriptTag) => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach((attribute) => {
          newScriptTag.setAttribute(attribute.name, attribute.value);
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }

    preventVariantURLSwitching() {
      const variantPicker = this.modalContent.querySelector('variant-selects');
      if (!variantPicker) return;

      variantPicker.setAttribute('data-update-url', 'false');
    }

    preventDuplicatedIDs() {
      const sectionId = this.productElement.dataset.section;
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
      this.productElement.querySelectorAll('variant-selects, product-info').forEach((element) => {
        element.dataset.originalSection = sectionId;
      });
    }

    removeDOMElements() {
      const pickupAvailability = this.productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();

      const productModal = this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();

      const modalDialog = this.productElement.querySelectorAll('modal-dialog');
      if (modalDialog) modalDialog.forEach((modal) => modal.remove());

      const sliderComponent = this.productElement.querySelector('slider-component');
      if (sliderComponent) sliderComponent.remove();

      const mediaGallery = this.productElement.querySelector('media-gallery');
      if (mediaGallery) mediaGallery.remove();
    }
  }

  customElements.define('quick-add-modal', QuickAddModal);
}

class QuickAddOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');
    if (!button) return;
    button.addEventListener('click', () => {
      const modalId = this.getAttribute('data-quick-add');
      const modal = document.querySelector(modalId);
      if (modal) {
        // Close all other modals before opening the new one
        document.querySelectorAll('quick-add-modal[open]').forEach(openModal => {
          if (openModal !== modal) {
            openModal.hide();
          }
        });
        modal.show(button);
      }
    });
  }
}

customElements.define('quick-add-opener', QuickAddOpener);
